import { render, staticRenderFns } from "./controlruleAction.vue?vue&type=template&id=5838dd94&scoped=true"
import script from "./controlruleAction.vue?vue&type=script&lang=js"
export * from "./controlruleAction.vue?vue&type=script&lang=js"
import style0 from "./controlruleAction.vue?vue&type=style&index=0&id=5838dd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838dd94",
  null
  
)

export default component.exports